<template>
  <div>
    <div v-if="loading && results.length === 0">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-9 offset-lg-2">

          </div>
        </div>
      </div>
    </div>
    <div class="">







      <div class="article-cards">

        <a class="article-card" v-bind:href="item.url" v-for="item in results">


          <div class="article-card__image">
            <responsive-image
                v-if="item.image"
                v-bind:image="item.image"
            ></responsive-image>
          </div>
          <div class="article-card__text">
            <div class="article-card__title-wrapper">
              <div class="article-card__title">{{ item.title }}</div>
            </div>
            <div class="article-card__date">
              <span class="capsize-inter">{{ item.date }}</span>
            </div>
          </div>


        </a>

      </div>



    </div>
    <div
        class="archive-load-more"
        v-if="results.length && (total > page * postsPerPage || loading)"
    >
      <button
          class="archive-load-more__button"
          v-on:click="loadMore"
          v-bind:disabled="loading"
      >
        {{context.i18n.load_more}}
      </button>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import ResponsiveImage from './ResponsiveImage.vue';
const CancelToken = axios.CancelToken;

export default {
  components: { ResponsiveImage },
  props: ['context'],
  computed: {},
  data: function() {
    return {
      page: 1,
      results: [],
      total: null,
      loading: false,
      postsPerPage: 10,
      cacheKey: 'npx2024_article_archive_cache',
    };
  },
  created() {
    this.results = this.context.initialData.posts;
    this.page = 1;
    this.total = this.context.initialData.total;
  },
  beforeMount() {
    let cached = window.sessionStorage.getItem(this.cacheKey);

    console.log('back forward?', this.isBackForward())

    if (cached && this.isBackForward()) {
      cached = JSON.parse(cached);
      this.results = cached.results;
      this.page = cached.page;
      this.total = cached.total;
    }
    if (cached && !this.isBackForward()) {
      window.sessionStorage.removeItem(this.cacheKey);
    }
  },
  mounted: function() {
    console.log('mounted');

    this.cancel = null;
  },
  methods: {
    isBackForward: function() {
      if (window.performance) {
        var navEntries = window.performance.getEntriesByType(
            'navigation'
        );
        if (
            navEntries.length > 0 &&
            navEntries[0].type === 'back_forward'
        ) {
          return true;
        } else if (
            window.performance.navigation &&
            window.performance.navigation.type ==
            window.performance.navigation.TYPE_BACK_FORWARD
        ) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    getPosts: function() {
      if (this.loading) {
        this.cancel();
      }
      this.loading = true;
      axios
          .get(this.context.apiUrl + 'npx2024/v1/archive', {
            params: {
              page: this.page,
              mwstats_lang: this.context.lang,
            },
            cancelToken: new CancelToken(c => {
              this.cancel = c;
            }),
          })
          .then(data => {
            this.results = this.results.concat(data.data.posts);
            this.total = data.data.total;

            window.sessionStorage.setItem(
                this.cacheKey,
                JSON.stringify({
                  results: this.results,
                  page: this.page,
                  total: this.total,
                })
            );

            this.loading = false;
          })
          .catch(error => {
            if (error instanceof axios.Cancel) {
              // Cancelled, no need to handle error
            } else {
              console.error('Error while getting archive', error);
              this.loading = false;
            }
          });
    },
    loadMore() {
      this.page = this.page + 1;
      this.getPosts();
    },
  },
};
</script>
